import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { LoginPage } from '@/features/auth/components/login-page';
import { sessionStore } from '@/shared/auth/session-store';
import { safeRedirectPath } from '@/shared/lib/redirect';

const searchSchema = z.object({
  /** 로그인 후 돌아갈 경로 (같은 사이트 안) */
  redirect: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/login')({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    if (sessionStore.get()) {
      throw redirect({ href: safeRedirectPath(search.redirect), replace: true });
    }
  },
  head: () => ({ meta: [{ title: '로그인 · 팬즈드롭 코인 충전' }] }),
  component: LoginRoute,
});

function LoginRoute() {
  const search = Route.useSearch();
  return <LoginPage redirect={search.redirect} />;
}
